// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__R_Lu6","warningContainer":"Header_warningContainer__F5dv2"};